<!--SKU编辑  -->
<template>
	<div class="dialogBox">
		<el-dialog title="合并计划" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:close-on-press-escape="false" :modal-append-to-body="false" width="1000px" :before-close="cancle" top="3vh">
			<div class="merge-content">
				<div class="icon-size">
					源计划：<i class="el-icon-circle-plus-outline ml10" @click="handleAddMerge('Y')"></i><i
						class="el-icon-remove-outline ml15" @click="handleDelete"></i>
				</div>
				<el-divider></el-divider>
				<el-table v-if="tableData.length>0" :data="tableData" @selection-change="handleSelectionChange"
					:header-cell-style="{background:'#C8CCD7',color:'#333333',height:'25px'}" border
					style="width: 100%">
					<el-table-column type="selection" width="55">
					</el-table-column>
					<el-table-column prop="planCode" label="计划编号" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="planDate" label="计划日期" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="routeName" label="路线名称" :show-overflow-tooltip="true">
					</el-table-column>
				</el-table>
				<div v-else class="tc mt15">暂无数据</div>
				<div class="icon-size mt15">
					目标计划:<i class="el-icon-circle-plus-outline ml10" @click="handleAddMerge('N')"></i><i
						class="el-icon-remove-outline ml15" @click="handleDeleteNc"></i>
				</div>
				<el-divider></el-divider>
				<el-table v-if="tableData1.length>0" :data="tableData1"
					:header-cell-style="{background:'#C8CCD7',color:'#333333',height:'25px'}" border
					style="width: 100%">
					<el-table-column prop="planCode" label="计划编号" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="planDate" label="计划日期" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="routeName" label="路线名称" :show-overflow-tooltip="true">
					</el-table-column>
				</el-table>
				<div v-else class="tc mt15">暂无数据</div>
			</div>
			<span slot="footer" class="dialog-footer mt10">
				<el-button size="small" @click="cancle()">取 消</el-button>
				<el-button size="small" type="primary" @click="submitForm()">合并</el-button>
			</span>
		</el-dialog>
		<addTour ref="addTour" @selectRows="selectRows" @selectNewFlag="selectNewFlag"></addTour>
		<tourEdit ref="tourEdit"></tourEdit>
	</div>
</template>

<script>
	import addTour from './add-tour.vue'
	import tourEdit from './tour-edit.vue'
	import {
		debounce
	} from '@/utils/debounce'
	export default {
		components: {
			addTour,
			tourEdit
		},
		data() {
			return {
				dialogVisible: false,
				agentIds: [],
				tableData: [],
				titles: [],
				ncCode: "",
				tableData1: [],
				titles1: [],
				multipleSelection: [],
				otherTable: [], //临时table,
				otherTitle: [], //临时table,
			}
		},
		created() {

		},
		methods: {
			init() {
				this.$nextTick(() => {
					this.dialogVisible = true
					this.tableData = []
					this.tableData1 = []
				})
			},
			//  添加客商信息
			handleAddMerge(val) {
				if (val == "Y" && this.tableData.length >= 10) {
					this.$message.error('只能添加10条源路线!');
					return
				}
				this.$refs.addTour.init(val == 'Y' ? this.tableData : this.tableData1, val)
			},

			// 删除目标客商
			handleDeleteNc() {
				this.tableData1 = []
			},
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 删除
			handleDelete() {
				let that = this;
				if (that.multipleSelection.length <= 0) {
					this.$message.error('请先选择!');
					return
				}
				that.multipleSelection.forEach((ele) => {
					that.tableData.forEach((item, index, arr) => {
						if (item.dataKey == ele.dataKey) {
							arr.splice(index, 1); //删除下标为i的元素
						}
					});
				});
				this.$forceUpdate()
			},
			// 选择的客商信息
			selectRows(val) {
				this.otherTable = val
			},
			// 判断是哪个表返回的数据
			selectNewFlag(val) {
				if (val == "Y") {
					this.tableData = this.unRepeat(this.otherTable, this.tableData)
				} else {
					this.tableData1 = this.otherTable
				}
			},
			// 去重
			unRepeat(json1, json2) {
				let json = json1.concat(json2); //两个数组对象合并
				console.log(json)
				let newJson = []; //盛放去重后数据的新数组
				json.forEach(item1 => {
					let flag = true; //建立标记，判断数据是否重复，true为不重复
					newJson.forEach(item2 => {
						if (item1.planId == item2.planId) { //让json数组对象的内容与新数组的内容作比较，相同的话，改变标记为false
							flag = false;
						}
					});
					if (flag) { //判断是否重复
						newJson.push(item1); //不重复的放入新数组。  新数组的内容会继续进行上边的循环。
					}
				});
				return newJson
			},
			// 保存
			submitForm: debounce(function () {
				let that = this;
				if (that.tableData.length <= 0) {
					that.$message.error('请选择路线!');
					return
				}
				if (that.tableData1.length <= 0) {
					that.$message.error('请选择目标路线!');
					return
				}
				let planIds = []
				that.tableData.forEach(item => {
					planIds.push(item.planId)
				});

				that.$confirm('确认要合并路线，把源路线的客商信息合并到目标路线里吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.$request.post(
							"roundPlanMergeAgent",
							true, {
								planIds: planIds,
								planId: that.tableData1[0].planId,
							}
						)
						.then((res) => {
							if (res) {
								that.dialogVisible = false
								that.$message.success("合并成功！");
								that.$emit("getList")
								that.$refs.tourEdit.init(that.tableData1[0])
							}
						})
				}).catch(() => {});
			}, 1000, true),
			// 取消
			cancle() {
				this.dialogVisible = false
			},
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.dialogBox {

		/deep/ .el-dialog__body {
			padding: 15px;
		}

		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 5px;
			}

			/deep/ td {
				padding: 5px;
			}
		}

		.el-divider--horizontal {
			margin: 15px 0;
		}
	}

	.icon-size {
		font-size: 16px;
		i{
			cursor: pointer;
		}
	}

</style>
